module.exports = __webpack_public_path__ + "img/EU_sufinanciranje.ec82f656.jpg";